module.exports = __webpack_public_path__ + "static/img/pitch_green_old.0c1c4a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_green_old.png
// module id = Sqbw
// module chunks = 94